<template>
  <div class="d-flex align-items-stretch card-rounded position-relative overflow-hidden mb-4 bg-iute-black text-white shadow-dark">
    <div class="banner-text px-3 pt-2 pb-3">
      <div class="handwriting-sm fs-6">{{ $t('CashPalBanner.title')}}</div>
      <h6 class="mb-1">{{ $t('CashPalBanner.getAmount', {name: firstName, amount: $n(palMaxAmount, 'currencyNoDecimals')})}}</h6>
      <div class="mt-n1 small">{{ $t('CashPalBanner.body') }}</div>
      <router-link :to="{name: 'new-loan'}" class="btn btn-primary btn-xs btn-with-icon mt-3">
        <span>{{ $t('CashPalBanner.applyNow') }}</span>
        <Icon icon-name="arrow-right" icon-class="icon-xs"/>
      </router-link>
    </div>
    <div class="banner-illustration banner-illustration-crop">
      <div class="banner-image"><img src="/img/bnnr/bnner-sq-girl-with-dog.png" :alt="$t('CashPalBanner.title')"></div>
    </div>
  </div>
</template>

<script>
import Icon from '@shared/components/Icon'
import store from '@shared/store'

export default {
  name: 'CashPalBanner',
  components: {
    Icon
  },
  props: ['palMaxAmount'],
  data() {
    return {
      firstName: store.state.currentUser.firstName
    }
  }
}
</script>

<style scoped>

.fs-6 {
  font-size: 1.25rem;
}

.btn-xs {
  padding: 2px 9.6px 3px;
  border-radius: 50rem;
  letter-spacing: 0;
  font-size: 12px;
}

</style>
